import React from 'react';
import { ChevronRight } from '@mui/icons-material';
import { Badge, Link, Typography } from '@mui/material';
// import { translate as t } from 'hooks/useTranslations';
import { type PendingAssignmentsSummary } from '../../../_types/policy';
import { error, info, neutral, success, warning } from '_lex/_foundations/phxColors';
import { PercentBarVariant } from 'components/_atoms/PercentBar';
import dayjs from 'dayjs';

type PendingAssignmentsSummaryProps = {
  summary: PendingAssignmentsSummary;
};

export default function PendingAssignmentsSummaryDisplay({ summary }: PendingAssignmentsSummaryProps) {
  let completionColor: PercentBarVariant = 'neutral';
  if (summary.completionPercentage > 0.85) {
    completionColor = 'success';
  } else if (summary.completionPercentage > 0.5) {
    completionColor = 'warning';
  } else {
    completionColor = 'danger';
  }

  const statusBadge = (dueAt: string | null) => {
    if (!dueAt) return null;
    const dueDate = dayjs(dueAt);
    const today = dayjs().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
    let badgeContent = 'Overdue';
    let badgeBgColor = error[50];
    let badgeColor = error[800];
    if (dueDate.isSame(today)) {
      badgeContent = 'Due Today';
    } else if (dueDate.isAfter(dayjs().add(30, 'day'))) {
      badgeContent = `${Math.ceil(dueDate.diff(today, 'week', true))} weeks left`;
    } else if (dueDate.isAfter(dayjs())) {
      badgeContent = `${Math.ceil(dueDate.diff(today, 'day', true))} days left`;
    }
    if (dueDate.isAfter(dayjs().add(7, 'day'))) {
      badgeBgColor = success[50];
      badgeColor = success[800];
    } else if (dueDate.isAfter(dayjs().startOf('day'))) {
      badgeBgColor = warning[50];
      badgeColor = warning[800];
    }

    return (
      <Badge
        variant='inline'
        badgeContent={badgeContent}
        color='neutral'
        sx={{
          '& .MuiBadge-badge.MuiBadge-inline': {
            backgroundColor: badgeBgColor,
            color: badgeColor,
          },
        }}
      />
    );
  };

  return (
    <Link
      className='pending-assignments-summary'
      href={`/admin/reporting/policy-acknowledgments#search=${encodeURIComponent(summary.title)}&completed=false`}
      underline='none'
      sx={{
        display: 'grid',
        gridTemplateColumns: '3fr 1fr auto',
        gap: 4,
        alignItems: 'center',
        p: 4,
        color: 'inherit',
        '&:hover': {
          backgroundColor: neutral[50],
        },
      }}
    >
      <Typography>{summary.title}</Typography>
      {/* 
      <Badge
        variant='inline'
        badgeContent={summary.type}
        color={summary.type === 'ACK' ? 'primary' : 'neutral'}
        sx={{
          textTransform: 'uppercase',
          '& .MuiBadge-badge': {
            backgroundColor: summary.type === 'ACK' ? info[50] : success[50],
            color: summary.type === 'ACK' ? info[800] : success[800],
          },
        }}
      />
      
      <PercentBar
        percent={summary.completionPercentage * 100}
        variant={completionColor}
      />
      */}
      {statusBadge(summary.dueAt ?? null)}
      <ChevronRight sx={{ color: neutral[400] }} />
    </Link>
  );
}
